/**
 * Pure port of the "latest task" logic in components/caseTracker/caseResult.js: the most recently
 * modified service-provider step across all treatments, else the first provider marked "Sent".
 */
export interface LatestTask {
  serviceProvider?: string;
  status?: string;
  lastModified?: string;
  treatmentType?: string;
}

export function getLatestTask(caseRow: any): LatestTask | null {
  const treatments: any[] = Array.isArray(caseRow?.caseTreatments) ? caseRow.caseTreatments : [];
  const tasks: LatestTask[] = [];

  treatments.forEach((ct) => {
    const providers: any[] = Array.isArray(ct?.serviceProviders) ? ct.serviceProviders : [];
    providers.forEach((sp) => {
      if (sp?.lastModified) {
        tasks.push({
          serviceProvider: sp.serviceProvider,
          status: sp.status,
          lastModified: sp.lastModified,
          treatmentType: ct.treatmentType,
        });
      }
    });
  });

  if (tasks.length > 0) {
    tasks.sort((a, b) => new Date(b.lastModified as string).getTime() - new Date(a.lastModified as string).getTime());
    return tasks[0];
  }

  const first = treatments[0]?.serviceProviders?.[0];
  if (!first) return null;
  return {
    serviceProvider: first.serviceProvider,
    status: 'Sent',
    lastModified: first.lastModified,
    treatmentType: treatments[0]?.treatmentType,
  };
}
